const React = require('react')
const Chart = require('react-apexcharts').default

const CustomLineChart = props => {
    const {
        colors = ['#00E396'],
        labels,
        series,
        width = '100%',
        height = '122',
        stacked = false
    } = props

    const chartData = {
        options: {
            chart: {
                id: 'basic-line',
                toolbar: { show: false },
                stacked: stacked,
                parentHeightOffset: 0,
                sparkline: {
                    enabled: false
                }
            },
            xaxis: {
                categories: labels,
                labels: {
                    show: true,
                    style: { colors: Array(7).fill('#8B8B8B') }
                },
                axisBorder: {
                    show: false,
                    height: 0
                },
                axisTicks: {
                    show: false
                }
            },
            yaxis: {
                show: false
            },
            colors,
            fill: {
                colors,
                type: 'gradient',
                gradient: {
                    type: 'vertical',
                    shadeIntensity: 1,
                    opacityFrom: 0.5,
                    opacityTo: 1,
                    stops: [0, 80, 100],
                    gradientToColors: colors,
                    invertColors: true
                }
            },
            dataLabels: {
                enabled: true,
                style: { fontSize: '9px' },
                background: { enabled: true }
            },
            stroke: {
                curve: 'smooth',
                width: 2
            },
            markers: {
                size: 1
            },
            grid: {
                show: false,
                padding: {
                    top: 0,
                    right: 40,
                    bottom: 0,
                    left: 30
                }
            },
            legend: {
                show: false
            },
            tooltip: {
                enabled: true,
                theme: 'dark'
            }
        }
    }

    return (
        <div className='line-chart'>
            <Chart
                key={JSON.stringify(series)}
                options={chartData.options}
                series={series}
                type='line'
                width={width}
                height={height}
            />
        </div>
    )
}

module.exports = { CustomLineChart }
